module.exports = __webpack_public_path__ + "img/GP-2134T标签打印机.bbd4c574.jpg";